import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../../context/Translator";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import AddFamilyDonor from "./AddFamilyDonor";
import EditFamilyDonor from "./EditFamilyDonor";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useNavigate } from "react-router-dom";
import './FamilyDonorStyles.css'

function ListFamilyDonor() {
	
	
	
	const navigate = useNavigate();

	const { t } = useContext(TranslatorContext);
	const AuthToken = localStorage.getItem("AuthUser");

	const [data, setData] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [showForm, setShowForm] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [editUser, setEditUser] = useState(null);

	useEffect(() => {

		const fetchData = async () => {
			try {
				axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
				const response = await axios.get(process.env.REACT_APP_API_URL + "/family-donors");
				setData(response.data);


			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};
		fetchData();
	}, []);
    
	// Handle search
	const handleSearch = (event) => {
		setSearchQuery(event.target.value.toLowerCase());
	};

	// Filter data
	// const filteredData = data?.filter((item) =>
	// 	Object.values(item).some((val) =>
	// 		String(val).toLowerCase().includes(searchQuery)
	// 	)
	// );
                const donors = data.donors;

	return (
		<>
			<PageLayout>
				<Row>
					<Col xl={12}>
						<div className="mc-card">
							<div className="mc-breadcrumb">
								<h3 className="mc-breadcrumb-title">
									List Family Donors
								</h3>
								<ul className="mc-breadcrumb-list">
									<li className="mc-breadcrumb-item">
										<Link
											to="#"
											style={{ color: "#077834" }}
										>
											Home
										</Link>
									</li>
									<li className="mc-breadcrumb-item">
										<Link
											to="#"
											style={{ color: "#077834" }}
										>
											Family Donors
										</Link>
									</li>
									<li className="mc-breadcrumb-item">
										List Family Donors
									</li>
								</ul>
							</div>
						</div>
					</Col>

					<Col xl={12}>
						<div className="mc-card">
							<Row>
								<Col xl={6}>
									<div className="add-button">
										<Button
											className=""
											style={{
												backgroundColor: "#077834",
												color: "white",
												border: "none",
											}}
											onClick={() => {
												setIsEditMode(false);
												setEditUser(null);
												setShowForm(true);
											}}
										>
											+
										</Button>
									</div>
								</Col>
								<Col xl={6}>
									<div className="mc-search">
										<input
											type="text"
											placeholder={t("search")}
											value={searchQuery}
											onChange={handleSearch}
											className="form-control table-search"
										/>
									</div>
								</Col>
							</Row>

							{/* Table */}
							<Row>
								<Col xl={12}>
									<table className="table">
										<thead>
											<tr>
												<th>#</th>
												<th>Name</th>
                                                <th>Actions</th>
												
											</tr>
										</thead>
										<tbody>
											{donors?.map(
												(donor, index) => (
													<tr key={donor.id || index}>
														<td>
															{index + 1}{" "}
														
														</td>
														<td>{donor.name}</td>
														<td>
															<div className=" d-flex justify-content-center">
																<Button
																	className=""
																	style={{
																		backgroundColor:
																			"#077834",
																		color: "#fff",
																		border: "1px solid #077834",
																	}}
																	onClick={() => {
																		setIsEditMode(
																			true
																		);
																		setEditUser(
																			donor
																		);
																		setShowForm(
																			true
																		);
																	}}
																>
																	Edit
																</Button>
															</div>

															
														</td>
													</tr>
												)
											)}
										</tbody>
									</table>
								</Col>
							</Row>

							{/* Modal  */}
							<Modal
								className="custom-dialog my-modal"
								show={showForm}
								onHide={() => setShowForm(false)}
								size="lg"
							>
								<Modal.Header closeButton>
									<Modal.Title></Modal.Title>
								</Modal.Header>
								<Modal.Body>
									{isEditMode ? (
										<EditFamilyDonor
											donor={editUser}
											setShowForm={setShowForm}
											setData={setData}
											data={data}
										/>
									) : (
										<AddFamilyDonor
											setShowForm={setShowForm}
											setData={setData}
											data={data}
										/>
									)}
								</Modal.Body>
							</Modal>
						</div>
					</Col>
				</Row>
			</PageLayout>
		</>
	);
}

export default ListFamilyDonor;
